module.exports = __webpack_public_path__ + "static/img/upload-skill-example.42072cae.png";